// extracted by mini-css-extract-plugin
export var actionButton = "_c9-5";
export var actionButtonActive = "_c9-6";
export var content = "_c9-3";
export var header = "_c9-4";
export var list = "_c9-7";
export var settingsContent = "_c9-a";
export var settingsPanel = "_c9-b";
export var settingsRow = "_c9-c";
export var state = "_c9-9";
export var triggerBadge = "_c9-2";
export var triggerButton = "_c9-1";
export var triggerShell = "_c9-0";
export var unreadDot = "_c9-8";